import styled from "styled-components";
import { css } from "styled-components";
import { sizes } from "./theme";

export const Container = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const ScrollContainer = styled(Container)`
  &::-webkit-scrollbar {
    height: 0.75vh;
    border-radius: 25px;
    /* width: 50vw; */
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.25);
    border-radius: 25px;
  }
  /* Set the color and size for the scrollbar thumb (handle) */
  &::-webkit-scrollbar-thumb {
    /* Set the color of the scrollbar thumb */
    background-color: ${({ theme, $color }) => theme[$color] || theme.secColor};
    border-radius: 50px; /* Set the border radius for a rounded appearance */
    height: 10vh;
  }
`;

export const Grid = styled.div`
  /* box-sizing:border-box; */
  /* position:relative; */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  gap: 1vh;
  width: 100%;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    grid-template-columns: repeat(1, 1fr);
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: center;
  /* padding: 0vh 5vw; */
  transition: transform 0.5s ease-in-out;
  transform: ${({ $hide }) =>
    $hide ? "translateY(-100%)" : "translateY(0)"};
  box-shadow: 0 -2px 2px ${({ theme }) => theme.shadowColor} inset;
  background-color: white;
  /* border: 2px solid red; */
`;

export const Header = styled.header`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4vh 7vw;
  background-size: cover;
  background-position: center center;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Main = styled.main`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Section = styled.section`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  /* background-color: ${({ theme, $bgColor }) => theme[$bgColor]}; */
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Dialog = styled.dialog`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  top: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10;
  border: none;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const SideBar = styled.aside`
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const FooterStyled = styled.footer`
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4vh;
  padding: 5vh 10vh;
  background-color: ${({ theme }) => theme.bgColor};
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    flex-direction: column;
    padding: 5vh 2vh;
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Address = styled.address`
  font-size: 2vh;
  font-weight: 600;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Img = styled.img`
  object-fit: cover;
  border-radius: 12px;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Button = styled.button`
  color: black;
  border: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", "sans-serif";
  background-color: inherit;
  cursor: pointer;
  &:active {
    transform: scale(0.9);
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;
export const FormButton = styled(Button)`
  min-width: 18vh;
  width: 30%;
  background-color: ${({ theme }) => theme.main};
  color: white;
  border-radius: 25px;
  font-size: 1.8vh;
  padding: 0.75vh 2vh;
  gap: 0.75vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Input = styled.input`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: ${({ theme, $error }) =>
    $error ? "1px solid red" : `1px solid ${theme.secColor}`};
  background-color: inherit;
  outline: none;
  font-size: 1.75vh;
  -webkit-appearance: textfield; /* WebKit browsers */
  -moz-appearance: none; /* Firefox */
  appearance: textfield; /* Standard */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Select = styled.select`
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  border: ${({ theme, $error }) =>
    $error ? "1px solid red" : `1px solid ${theme.secColor}`};
  background-color: transparent;
  border-radius: 12px;
  font-size: 1.75vh;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Option = styled.option`
  ${({ $baseStyle }) => $baseStyle};
`;

export const Anchor = styled.a`
  font-family: "Poppins", sans-serif;
  font-size: 2.25vh;
  display: flex;
  align-items: center;
  gap: 1vh;
  /* font-size:100%; */
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Strong = styled.strong`
  font-family: "Poppins", "sans-serif";
  font-size: 2.25vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Span = styled.span`
  display: flex;
  align-items: center;
  font-family: ${({ $fFamily, theme }) => theme[$fFamily] || "Poppins"},
    sans-serif;
  /* color: ${({ $color, theme }) => theme[$color] || "black"}; */
  font-size: 1.75vh;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const H1 = styled.h1`
  font-family: "Poppins";
  margin: 0;
  font-size: 5vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    font-size: 3.5vh;
    ${({ $mStyle }) => $mStyle}
  }
`;

export const H2 = styled.h2`
  font-family: "Poppins";
  margin: 0;
  color: ${({ theme }) => theme.main};
  font-size: 3.5vh;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    font-size: 3vh;
    ${({ $mStyle }) => $mStyle}
  }
`;

export const H3 = styled.h3`
  font-family: "Poppins";
  margin: 0;
  font-size: 3vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const H4 = styled.h4`
  margin: 0;
  display: flex;
  font-size: 2vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;
export const H5 = styled.h5`
  margin: 0;
  display: flex;
  font-size: 2vh;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Form = styled.form`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-weight: 200;
  font-family: "Poppins", sans-serif;
  font-size: 1.5vh;
  color: ${({ theme }) => theme.secColor};
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const TextArea = styled.textarea`
  border: ${({ theme, $error }) =>
    $error ? "1px solid red" : `1px solid ${theme.secColor}`};
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  border-radius: 6px;
  white-space: pre-line;
  outline: none;
  resize: none;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Paragraph = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 2vh;
  margin: 0;
  color: ${({ theme }) => theme.thirdColor};
  white-space: pre-wrap;
  ${({ $baseStyle }) => $baseStyle}
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Arrow = styled.div`
  border-style: solid;
  border-color: ${({ theme }) => theme.main};
  border-width: 0 0.5vh 0.5vh 0;
  display: inline-block;
  padding: 1vh;
  border-radius: 3px;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
  ${({ $direction }) =>
    $direction === "right"
      ? css`
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        `
      : $direction === "left"
      ? css`
          transform: rotate(135deg);
          -webkit-transform: rotate(135deg);
        `
      : $direction === "up"
      ? css`
          transform: rotate(-135deg);
          -webkit-transform: rotate(-135deg);
        `
      : $direction === "down"
      ? css`
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        `
      : null}
`;

export const Line = styled.div`
  box-sizing: border-box;
  border: 2px solid;
  width: 100%;
  height: 0;
  border-radius: 25px;
  border-color: ${({ theme }) => theme.main};
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const Dot = styled.div`
  width: 1vh;
  height: 1vh;
  background-color: ${({ $active, theme }) =>
    $active ? theme.main : theme.shadowColor};
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
  ${({ $baseStyle }) => $baseStyle};
  @media (max-width: ${sizes.laptop}) {
    ${({ $tStyle }) => $tStyle}
  }
  @media (max-width: ${sizes.tablet}) {
    ${({ $mStyle }) => $mStyle}
  }
`;

export const IsRequiredStar = styled.span`
  /* z-index: 2; */
  color: red !important;
  /* font-weight: bold; */
  &::before {
    content: "*";
  }
`;
